import { FormWithRedux } from '../FormWithRedux';
import { FormLoader } from '../FormLoader';

export class GenericFrom extends FormWithRedux {

    get pathwayId() {
        return  'environmentInfoForm'; //this._pathwayId
    }

    set pathwayId(value) {
        this._pathwayId = value;
    }

    subform(identifier) {
        return FormLoader.form(this.pathwayId, identifier);
    }

    formDetail(identifier) {
        return FormLoader.formDetail(this.pathwayId, identifier);
    }

    constructor(identifier, pathwayId) {
        super(identifier);
        this.pathwayId = pathwayId;
    }

    generateSubform(identifier) {
        return new GenericFrom(identifier, this.pathwayId);
    }

    shouldDisplayFormDetailForIdentifier() {
        return true;
    }

    isEnabled(identifier) {
        if (identifier != null) {
            return true;
        }
        return false;
    }

    isMandatory() {
        return true;
    }

    getValueType() {
        return 'string';
    }

    editingValidation(){
        return [];
    }

    submissionValidation() {
        return [];
    }

    detailString() {
        return this.detail;
    }
}


// WEBPACK FOOTER //
// ./src/forms/sharedForms/GenericForm.js